// Dataset activity route (/admin/datasets/activity): action, entity, actor and since filters in the URL; the screen is ActivityPage with the audit trail and chain verification.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { zDatasetAction } from "@/api/__generated__/zod.gen";
import { optionalList, optionalString } from "@/app/search";
import { ActivityPage } from "@/features/datasets/ActivityPage";

const searchSchema = z.object({
  action: optionalList(zDatasetAction),
  entity: optionalString(),
  actor: optionalString(),
  since: optionalString(),
});

export const Route = createFileRoute("/_app/admin/datasets/activity")({
  validateSearch: searchSchema,
  staticData: { crumb: "Activity" },
  component: ActivityPage,
});
